import { render, staticRenderFns } from "./PscInspectionByMou.vue?vue&type=template&id=2ba6adb9&scoped=true&"
import script from "./PscInspectionByMou.vue?vue&type=script&lang=js&"
export * from "./PscInspectionByMou.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba6adb9",
  null
  
)

export default component.exports